module.exports = __webpack_public_path__ + "img/ic_qmarker_generic_cluster.701f0fe9.png";